const translations = {
    closeText: 'Close',
    openText: 'Open'
};

export default translations;
